require('./rating-stars.less');

jQuery(function() {
    var setStars = function($ratingStars) {
        if ($ratingStars == undefined) $ratingStars = $('.js-rating-stars');

        var $elementRate = $ratingStars.find('.rating-stars__star-yellow');
        var curSelectedValElementRate = $elementRate.filter('.rating-stars__star-yellow--filled').length;

        $ratingStars.each(function() {
            var $this = $ratingStars;
            var $stars = $this.find('.rating-stars__star');
            var $input = $this.find('.rating-stars__hidden-value');

            var curSelectedVal = $stars.filter('.rating-stars__star--filled').length;
            if (curSelectedVal >= 1) curSelectedVal -= 1;

            $stars.hover(
                function() {
                    var $curStar = $(this);
                    $stars.removeClass('rating-stars__star--filled');
                    $curStar
                        .prevAll('.rating-stars__star')
                        .andSelf()
                        .addClass('rating-stars__star--hover');
                },
                function() {
                    $stars.removeClass('rating-stars__star--hover');
                    $stars.slice(0, curSelectedVal).addClass('rating-stars__star--filled');
                }
            );

            $stars.click(function() {
                var $curStar = $(this);
                $curStar
                    .prevAll('.rating-stars__star')
                    .andSelf()
                    .addClass('rating-stars__star--filled');

                curSelectedVal = $stars.filter('.rating-stars__star--filled').length;
                $input.val(curSelectedVal);
            });

            if (curSelectedValElementRate >= 1) curSelectedValElementRate -= 1;

            $elementRate.hover(
                function() {
                    var $curStar = $(this);
                    $elementRate.removeClass('rating-stars__star-yellow--filled');
                    $curStar
                        .prevAll('.rating-stars__star-yellow')
                        .andSelf()
                        .addClass('rating-stars__star-yellow--hover');
                },
                function() {
                    $elementRate.removeClass('rating-stars__star-yellow--hover');
                    $elementRate.slice(0, curSelectedValElementRate).addClass('rating-stars__star-yellow--filled');
                }
            );
        });
    };

    setStars();

    module.exports.setStars = setStars;
});

/* При клике на звездочку устаналиваем оценку для элемента */
$('.js-rating-stars')
    .find('.rating-stars__star-yellow')
    .one('click', function() {
        var $curStar = $(this);
        $curStar
            .prevAll('.rating-stars__star-yellow')
            .andSelf()
            .addClass('rating-stars__star-yellow--filled');
        $.ajax({
            url: '/ajax/action/element_rate/add/',
            data:
                'rating=' +
                $('.js-rating-stars')
                    .find('.rating-stars__star-yellow')
                    .filter('.rating-stars__star-yellow--filled').length +
                '&element_id=' +
                $('input[name="rate_element_id"]').val() +
                '&entity_id=' +
                $('input[name="rate_entity_id"]').val(),
            success: function() {
                $.ajax({
                    url: '/ajax/component/maximaster:element.rate/element/',
                    data:
                        'ENTITY_ID=' +
                        $('input[name="rate_entity_id"]').val() +
                        '&ELEMENT_ID=' +
                        $('input[name="rate_element_id"]').val(),
                    success: function(result) {
                        $('.product-card__element_rate-container').html(result.html);
                    }
                });
            }
        });
    });

/* Вызываем окно авторизации, если кликает не авторизированный пользователь */
$(document).on('click', '.js-rating-show-auth', function() {
    if (!$('.jqi').hasClass('shown')) {
        $('.js-jqi-show-login').trigger('click');
    }
});



// WEBPACK FOOTER //
// ./blocks/rating-stars/rating-stars.js